module.exports = __webpack_public_path__ + "img/usecase01.16f2156c.png";